import Vue from 'vue';

Vue.filter('price', (input, decimals = true) => {
    const value = parseFloat(input);
    let output = value || value === 0 ? value.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' }) : '';
    if (!decimals) {
        output = output.slice(0, -3);
    }
    return output;
});
